module.exports = __webpack_public_path__ + "img/emoji_103.e83b93d9.png";